import { EstateRoute } from '/@/modules/estate/constants/EstateRoute';
import { EstateDashboardRouteConfig } from '/@/modules/estate/routes/EstateDashboardRouteConfig';
import { ManageEstateRouteConfig } from '/@/modules/estate/routes/ManageEstateRouteConfig';
import { EstateSettingsRouteConfig } from '/@/modules/estate/routes/EstateSettingsRouteConfig';
import { EstateSummaryRouteConfig } from '@/modules/estate/routes/EstateSummaryRouteConfig';

export const router = [
  EstateDashboardRouteConfig.factory({
    path: `/${EstateRoute.DASHBOARD}`,
    name: EstateRoute.DASHBOARD,
    component: () => import('/@/modules/estate/pages/EstateDashboardPage.vue')
  }).build(),
  ManageEstateRouteConfig.factory({
    path: `/${EstateRoute.OVERVIEW}`,
    name: EstateRoute.OVERVIEW,
    component: () => import('/@/modules/estate/pages/EstateManageOverviewPage.vue')
  }).build(),
  ManageEstateRouteConfig.factory({
    path: `/${EstateRoute.PLANNING}`,
    name: EstateRoute.PLANNING,
    component: () => import('/@/modules/estate/pages/EstateManagePlanningPage.vue')
  }).build(),
  ManageEstateRouteConfig.factory({
    path: `/${EstateRoute.SETTLEMENT}`,
    name: EstateRoute.SETTLEMENT,
    component: () => import('/@/modules/estate/pages/EstateManageSettlementPage.vue')
  }).build(),
  EstateSummaryRouteConfig.factory({
    path: `/${EstateRoute.SUMMARY.path}`,
    name: EstateRoute.SUMMARY.name,
    component: () => import('/@/modules/estate/pages/EstateManageSummaryPage.vue')
  }).build(),
  ManageEstateRouteConfig.factory({
    path: `/${EstateRoute.ANALYTICS}`,
    name: EstateRoute.ANALYTICS,
    component: () => import('/@/modules/estate/pages/EstateManageAnalyticsPage.vue')
  }).build(),
  {
    path: EstateRoute.ESTATE.path,
    component: () => import('/@/modules/auth/pages/AuthUserPage.vue'),
    children: [
      {
        path: '',
        redirect: EstateRoute.SETTINGS.path
      },
      EstateSettingsRouteConfig.factory({
        path: EstateRoute.SETTINGS.path,
        name: EstateRoute.SETTINGS.name,
        component: () => import('/@/modules/estate/pages/EstateSettingsPage.vue')
      }).build()
    ]
  }
];
